import H5AudioPlayer from "react-h5-audio-player";
import PlayIcon from "@/assets/icons/audio-play.svg";
import PauseIcon from "@/assets/icons/audio-pause.svg";
import { twMerge } from "tailwind-merge";
import useIsMounted from "@/shared/hooks/useIsMounted";
import { useEffect, useRef } from "react";

const AudioPlayer = ({ src, className, isFullScreenOpen }: any) => {
  const isMount = useIsMounted();
  const player = useRef<H5AudioPlayer>(null);
  useEffect(() => {
    if (!isFullScreenOpen && !!player.current?.audio.current) {
      player.current.audio.current.pause();
      player.current.audio.current.currentTime = 0;
    }
  }, [isFullScreenOpen]);
  return (
    isMount && (
      <H5AudioPlayer
        ref={player}
        src={src}
        className={twMerge(className)}
        showJumpControls={false}
        customAdditionalControls={[]}
        customVolumeControls={[]}
        layout="horizontal-reverse"
        preload="auto"
        customIcons={{
          play: <PlayIcon />,
          pause: <PauseIcon />,
        }}
      />
    )
  );
};

export default AudioPlayer;
